import { ZyNodeViewWrapper } from '@/components/common/node-view-wrapper';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/tiptap-editor/tiptap-ui-primitive/tooltip/tooltip';
import type { ReactNodeViewProps } from '@tiptap/react';
import { NodeViewContent } from '@tiptap/react';

export default function ZyDefnBlockNodeView(props: ReactNodeViewProps) {
    const hasTerm = (() => {
        let found = false;
        props.node.descendants(child => {
            if (child.type?.name === 'zydefTerm') {
                found = true;
                return false;
            }
            return true;
        });
        return found;
    })();

    return (
        <ZyNodeViewWrapper decorations={props.decorations}>
            <div
                className={`rounded-md border px-3 py-2 hover:bg-opacity-100 ${
                    hasTerm
                        ? 'border-purple-200 bg-purple-50 text-purple-900 hover:bg-purple-100'
                        : 'border-red-200 bg-red-50 text-red-900 hover:bg-red-100'
                }`}
            >
                <Tooltip
                    delay={0}
                    closeDelay={0}
                >
                    <TooltipTrigger asChild>
                        <div
                            contentEditable={false}
                            className={`mb-2 inline-block rounded-sm px-1.5 text-xs text-white ${hasTerm ? 'bg-purple-600' : 'bg-red-600'}`}
                        >
                            <span>def</span>
                        </div>
                    </TooltipTrigger>
                    {!hasTerm && <TooltipContent>Select a term inside this definition</TooltipContent>}
                </Tooltip>
                <NodeViewContent />
            </div>
        </ZyNodeViewWrapper>
    );
}
